import periodsFilter from 'vacations-absences.module/common/filters/periods';

export default () => {
  return function (employeeList, filters, currentDate) {
    if (filters.length === 0){
      return employeeList;
    }

    let response = [];
    employeeList.forEach((employee)=>{
      let periods = periodsFilter()(employee.periods,filters).filter((period)=>{
        let startDate = new Date(period.startDate);
        let endDate = new Date(period.endDate);
        let sameMonth = currentDate.getMonth() === startDate.getMonth() || currentDate.getMonth() === endDate.getMonth() ;
        let sameYear =  currentDate.getYear() === startDate.getYear() || currentDate.getYear() === endDate.getYear();
        let isCurrentDateBetweenStartAndEnd = currentDate > startDate  && currentDate < endDate;

        return sameMonth && sameYear || isCurrentDateBetweenStartAndEnd;
      });
      if( periods.length > 0){
        response.push(employee);
      }
    });
    return response;
  };
};



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendar/managerYearInline/managerYearInline.filters.js